import _ from 'underscore';
import Localizer from 'localizer';
import Backbone from 'backbone';

import NavigationUtil from 'utils/NavigationUtil';
import { DEFAULT_GROUP_IMAGE } from 'constants/index';
import { REQUEST_KEY } from 'models/notification/inboxConstants';
import templateHtml from 'templates/notification/InboxPageLinkView.html';

// utils -- userSocialProfileImage
import profileImageHelperV2 from 'utils/userSocialProfileImage/profileImageHelperV2';
import 'utils/userSocialProfileImage/profileImageTypeDefsV2';

const InboxPageLinkView = Backbone.View.extend({
    events: {},

    initialize: function(args) {
        this.template = _.template(templateHtml);
        this.inboxRequestCount = args.inboxRequestCount;
        this.gcPlusFrameRole = args.gcPlusFrameRole; // Clean up ticket: CA-165763
    },

    render: function() {
        const i18nSeeAllRequests = Localizer.localize('see_all_requests');
        const i18nYouHaveNRequests = Localizer.localize(
            'you_have_n_requests',
            this.inboxRequestCount.get('requestCount')
        );
        const inboxUrl = NavigationUtil.url('/inbox');
        const { unread, imageUrls } = this.getUnreadStatusAndImageUrls();

        this.$el.html(
            this.template({
                i18nSeeAllRequests,
                i18nYouHaveNRequests,
                imageUrls,
                inboxUrl
            })
        );
        if (unread) {
            this.$('.request-item.inbox-link').addClass('unread');
        }
    },

    getUnreadStatusAndImageUrls: function() {
        if (this.gcPlusFrameRole?.featureEnabled()) {
            // Clean up ticket: CA-165763
            return this.getUnreadStatusAndImageUrlsWithFrame();
        }
        let unread = false;
        const inboxRequestsCountJSON = this.inboxRequestCount.toJSON();
        const imageUrls = inboxRequestsCountJSON.requests.map((item) => {
            unread = unread || !item.data.requestViewed;
            switch (item.requestKey) {
                case REQUEST_KEY.CONNECTION_REQUEST:
                    return item.data.profileImageUrlMedium || profileImageHelperV2.getDefaultProfileImage();
                case REQUEST_KEY.GROUP_JOIN_REQUEST:
                case REQUEST_KEY.GROUP_INVITE:
                    return item.data.profileImageUrlSmall || DEFAULT_GROUP_IMAGE;
                case REQUEST_KEY.ADHOC_INVITE:
                case REQUEST_KEY.KIDADHOC_INVITE:
                case REQUEST_KEY.KIDTEAM_INVITE:
                    return item.data.invitorImageUrl || profileImageHelperV2.getDefaultProfileImage();
                case REQUEST_KEY.DEVICE_INVITE:
                    return item.data.invitorProfilePicURL || profileImageHelperV2.getDefaultProfileImage();
            }
        });
        return { unread, imageUrls };
    },

    getUnreadStatusAndImageUrlsWithFrame: function() {
        let unread = false;
        const inboxRequestsCountJSON = this.inboxRequestCount.toJSON();
        const { profileInfos } = inboxRequestsCountJSON;
        const imageUrls = inboxRequestsCountJSON.requests.map((item) => {
            unread = unread || !item.data.requestViewed;
            switch (item.requestKey) {
                case REQUEST_KEY.CONNECTION_REQUEST:
                    return this.getProfileImageFromProfileInfos(
                        profileInfos,
                        item.data.userId,
                        item.data.profileImageUrlMedium,
                        false
                    );
                case REQUEST_KEY.GROUP_JOIN_REQUEST:
                case REQUEST_KEY.GROUP_INVITE:
                    return this.getProfileImageFromProfileInfos(
                        profileInfos,
                        item.data.userProfileId,
                        item.data.profileImageUrlSmall,
                        false
                    );
                case REQUEST_KEY.ADHOC_INVITE:
                case REQUEST_KEY.KIDADHOC_INVITE:
                case REQUEST_KEY.KIDTEAM_INVITE:
                    return this.getProfileImageFromProfileInfos(
                        profileInfos,
                        item.data.invitorId,
                        item.data.invitorImageUrl,
                        false
                    );
                case REQUEST_KEY.DEVICE_INVITE:
                    return this.getProfileImageFromProfileInfos(
                        profileInfos,
                        item.data.invitorId,
                        item.data.invitorProfilePicURL,
                        false
                    );
            }
        });
        return { unread, imageUrls };
    },

    getProfileImageFromProfileInfos: function(profileInfos, key, fallbackUrl, icon) {
        if (!profileInfos || !key) {
            return null;
        }
        /**
         * @type {SimplePublicSocialProfileV2DTO}
         */
        const dto = profileInfos?.[key];
        if (icon) {
            return profileImageHelperV2.getDtoMediumIconImage(dto, fallbackUrl);
        }
        return profileImageHelperV2.getDtoMediumFrameImage(dto, fallbackUrl);
    }
});

export default InboxPageLinkView;
